import { render, staticRenderFns } from "./JobShortcutsWrapper.vue?vue&type=template&id=73aa6458&scoped=true&"
import script from "./JobShortcutsWrapper.vue?vue&type=script&lang=js&"
export * from "./JobShortcutsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./JobShortcutsWrapper.vue?vue&type=style&index=0&id=73aa6458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa6458",
  null
  
)

export default component.exports